import { useNavigate, useParams } from "react-router-dom";
import { useVotacao } from "../../contexts/VotacaoContext";
import styled, { keyframes } from "styled-components";
import { useEffect, useState } from "react";
import axios from "axios";
import { TbLoader2 } from "react-icons/tb";

import Overlay from "../../Componentes/Overlay"
import Modal from "../../Componentes/Utils/Modal"
import SmallLoading from "../../Componentes/Utils/SmallLoading"
import { useToast } from "../../contexts/ToastContext";

const Container = styled.div`
    width: 100%;
    display: flex;
`
const ContainerPic = styled.div`
    width: 250px;
    aspect-ratio: 3/4;
    border: 1.8px solid #000;
    box-sizing: border-box;
    display: flex;
    overflow: hidden;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`
const ContainerInfo = styled.div`
    flex: 1;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 5px;
`
const ContainerTexts = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    p {
        margin: 0;
    }
`
const TextInfo = styled.p`
    font-size: 13px;
    margin: 0;
`
const InputChapaContainer = styled.div`
    width: 110px;
    height: 130px;
    margin: auto;
    border: 1.8px solid #000;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
`
const Input = styled.input`
    border: none;
    outline: none;
    flex: 1;
    height: 100%;
    font-size: 45px;
    text-align: center;
`
const BotaoSave = styled.button`
    width: 100%;
    height: 45px;
    background-color: ${({ canClick }) => (canClick ? "#326fec" : "#ededed")};
    color: ${({ canClick }) => (canClick ? "#fff" : "#b0b0b0")};
    margin: 0 auto;
    border: none;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
`
const spin = keyframes`
    from{
        rotate: 0deg;
    }
    to{
        rotate: 360deg;
    }
`
const IconeDownload = styled(TbLoader2)`
    width: 30px;
    height: 30px;
    margin: auto;
    color: #fff;
    animation: ${spin} 1s linear infinite;
`

const VoteCandidato = () => {

    const { cc, ano } = useParams();
    const { cpf, setCpf, setValidUser } = useVotacao();
    const { notifySuccess, notifyError } = useToast();

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [candidatos, setCandidatos] = useState([]);
    const [chapa, setChapa] = useState('');
    const [candidato, setCandidato] = useState(null);
    const [canVote, setCanVote] = useState(false);

    const getCandidatos = async () => {
        setLoading(true)
        try {
            const { data } = await axios.post(`https://sistemaintegrado.palmont.com.br/Painel/API/Cipa/GetCandidatos/`, {
                'centro_custo': cc,
                'ano': ano
            })
            setCandidatos(data);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {

        getCandidatos();

    }, [])

    const handleChange = (e) => {
        let valor = e.target.value.replace(/\D/g, "");
        setChapa(valor);
    }

    useEffect(() => {
        if (chapa === '') {
            setCandidato(null)
            setCanVote('')
            return;
        }

        const found = candidatos.find(c => String(c.chapa) === chapa);
        setCandidato(found || null);
        setCanVote(!!found);
    }, [chapa])

    const audio = new Audio("/sons/success.mp3");
    const successAudio = () => {
        audio.play();
    }

    const saveVote = async () => {

        if (!canVote) return;
        setSaving(true);

        try {
            const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/Cipa/SaveVote/', {
                'cpf': cpf,
                'centro_custo': cc,
                'ano': ano,
                'chapa': chapa
            })

            console.log(data);
            notifySuccess("Voto computado com sucesso!");
            successAudio();
            setCpf('');
            setValidUser(false);

        } catch (e) {
            console.error(e);
            notifyError('Erro ao cadastrar voto.')
            navigate('./../../../');
        } finally {
            setSaving(false);
        }

    }

    return (
        <>
            <Container>
                <ContainerPic>
                    {candidato?.foto && (<img src={candidato.foto} />)}
                </ContainerPic>
                <ContainerInfo>
                    <ContainerTexts>
                        <TextInfo><strong>CANDIDATO:</strong> {candidato?.nome ? candidato.nome : ''}</TextInfo>
                        <TextInfo><strong>APELIDO:</strong> {candidato?.apelido ? candidato.apelido : ''}</TextInfo>
                        <TextInfo><strong>FUNÇÃO:</strong> {candidato?.funcao ? candidato.funcao : ''}</TextInfo>
                    </ContainerTexts>
                    <InputChapaContainer>
                        <Input
                            maxLength={2}
                            onChange={handleChange}
                            value={chapa}
                            placeholder="00"
                        />
                    </InputChapaContainer>
                    <BotaoSave
                        canClick={canVote}
                        onClick={saveVote}
                        disabled={ saving }
                    >
                        {saving ? <IconeDownload /> : "SALVAR"}
                    </BotaoSave>
                </ContainerInfo>
            </Container>
            {
                loading && (
                    <Overlay state={true} >
                        <Modal size="sm" >
                            <SmallLoading />
                        </Modal>
                    </Overlay>
                )
            }
        </>
    )
}

export default VoteCandidato;